import { render, staticRenderFns } from "./Braip.vue?vue&type=template&id=0157b5a5&"
import script from "./Braip.vue?vue&type=script&lang=js&"
export * from "./Braip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports